package com.macrofocus.nastac.ui.layer

import com.macrofocus.nastac.ui.hexToRgba
import deckgl.GeoJsonLayer
import js.objects.unsafeJso

fun createPSPMLayer(visible: Boolean, year: Int): GeoJsonLayer {
    return GeoJsonLayer(unsafeJso {
        id = "pspm-$year"

        this.visible = visible

        this.data = "/edges.geojson"

        this.pickable = true
        asDynamic().stroked = false
        asDynamic().filled = true
        asDynamic().extruded = true
        asDynamic().pointType = "circle"
        asDynamic().lineWidthScale = 1000
        asDynamic().lineWidthMinPixels = 2
        asDynamic().getFillColor = arrayOf(255, 255, 0, 200)
        asDynamic().getLineColor = { d : dynamic -> hexToRgba(d.properties.color as String, 255 - (180.0 * (1.0 - d.properties.prob.unsafeCast<Double>())).toInt()) }
        asDynamic().getPointRadius = 100
        asDynamic().getLineWidth = 10
        asDynamic().getElevation = 30

        asDynamic().getFilterValue = { d: dynamic ->
            val from = (d.properties.year_start as? Number)?.toInt()
            val to = (d.properties.year_end as? Number)?.toInt()
            if (from != null && to != null && year >= from && year <= to) 1.0 else 0.0
        }
        asDynamic().filterRange = arrayOf(1.0, 1.0)
        updateTriggers = unsafeJso {
            this.asDynamic().getFilterValue = arrayOf(year)
        }

        extensions = arrayOf(deckgl.DataFilterExtension(unsafeJso {
            filterSize = 1
        }))
    })
}